// components/FAQSection.jsx
import React, { useState } from 'react';

export default function FAQSection() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        { q: "What is Arxis Accounting and who is it for?", a: "Arxis Accounting is a complete financial management platform designed specifically for sole proprietors, small and medium businesses in Nigeria who want accurate books, VAT compliance, and automation without the complexity of traditional software." },
        { q: "How does pricing work?", a: "All prices are VAT-inclusive. You can pay monthly or annually (with built-in savings). Start with a 14-day free trial — no credit card required." },
        { q: "What happens after I start a trial or purchase?", a: "You'll get instant access to your chosen plan. Our onboarding wizard guides you through setup, and you can import existing data in minutes." },
        { q: "What plan is right for me?", a: "Basic is perfect for single-location businesses. Standard suits growing teams needing multi-location or AI insights. Enterprise is built for larger operations requiring integrations and dedicated support." },
        { q: "What devices can I use?", a: "Arxis works seamlessly on desktop, tablet, and mobile browsers. Native apps for iOS and Android are coming soon." },
        { q: "Can I import my existing data?", a: "Yes! Easily import customers, suppliers, inventory, and historical transactions via CSV or direct Excel upload." },
        { q: "How do I access support?", a: "In-app live chat, email support, and phone support (business hours). Enterprise plans include a dedicated manager." },
    ];

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-4xl mx-auto px-6 lg:px-8">
                <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
                    Frequently Asked Questions
                </h2>
                <div className="space-y-4">
                    {faqs.map((faq, i) => (
                        <div key={i} className="bg-white rounded-lg shadow-md">
                            <button
                                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                                className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-gray-50 transition"
                            >
                                <span className="font-semibold text-lg">{faq.q}</span>
                                <span className="text-2xl">{openIndex === i ? '−' : '+'}</span>
                            </button>
                            {openIndex === i && (
                                <div className="px-6 pb-5 text-gray-600">
                                    {faq.a}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}